module.exports = __webpack_public_path__ + "static/Hollie-Crompton-3ad1f4f917fa18eef87a4124ccb30a79.jpg";